import { Observable } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

@Injectable()
export class HttpClientResponseInterceptor implements HttpInterceptor {
    constructor(
        @Inject('BaseURL') private readonly baseURL,
        @Inject('OAuthModel') private readonly oAuthModel,
    ) {}

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        request = request.clone({
            url: request.url.match(/http|https/) ? request.url : `${ this.baseURL }${ request.url }`,
            headers: request.headers
                .set('Device-info', `${ this.oAuthModel.data && this.oAuthModel.data.deviceType }`)
                .set('Authorization', `Bearer ${ this.oAuthModel.data && this.oAuthModel.data.token }`),
        });

        return next.handle(request);
    }
}
